import { createAction } from 'redux-actions';
import {
  SECTION_OFFSET_CHANGE,
  SECTION_SET_IN_VIEW,
} from './types';

export const changeOffset = createAction(SECTION_OFFSET_CHANGE, section => section);
export const setInView = createAction(SECTION_SET_IN_VIEW, section => section);



/** WEBPACK FOOTER **
 ** ./web/js/actions/section.js
 **/